<template>
    <div class="mobile-sidebar" :class="{open: openSendwich, 'yassytower-sidebar': projectHost == 'yassytower'}" v-if="setup != null" >
        <div class="mobile-lang">
            <ul class="lang-link-select" v-if="projectHost != 'kohota'">
                <li class="body-lang-ru"><a href="#" @click.prevent="setLocale('')" :class="{'active': lang == ''}">Рус</a></li>
                <li class="body-lang-kz"><a href="#" @click.prevent="setLocale('kz/')" :class="{'active': lang == 'kz/'}">Каз</a></li>
            </ul>
            <ul class="lang-link-select" v-if="projectHost == 'kohota'">
                <li class="body-lang-ru"><a href="#" @click.prevent="setLocale('ru/')" :class="{'active': lang == ''}">RU</a></li>
                <li class="body-lang-uz"><a href="#" @click.prevent="setLocale('uz/')" :class="{'active': lang == 'uz/'}">UZ</a></li>
            </ul>
        </div>
        <div class="sidebar-land-nav" v-if="salesCardPage != null && salesCard != null">
            <ul>
                <li v-if="salesCard.project_land_site.about_init == 'true'"><a :href="salesCardPage.land_site_nav[0].link" @click="closeMobileMenu(!openSendwich)"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[0].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[0].name}}</a></li>
                <li v-if="salesCard.project_land_site.location_init == 'true'"><a :href="salesCardPage.land_site_nav[1].link" @click="closeMobileMenu(!openSendwich)"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[1].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[1].name}}</a></li>
                <li v-if="salesCard.project_land_site.genplan_init == 'true'"><a :href="salesCardPage.land_site_nav[2].link" @click="closeMobileMenu(!openSendwich)"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[2].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[2].name}}</a></li>
                <li v-if="salesCard.project_land_site.prems_init == 'true'"><a :href="salesCardPage.land_site_nav[3].link" @click="closeMobileMenu(!openSendwich)"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[3].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[3].name}}</a></li>
                <li v-if="salesCard.project_land_site.arch_init == 'true'"><a :href="salesCardPage.land_site_nav[4].link" @click="closeMobileMenu(!openSendwich)"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[4].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[4].name}}</a></li>
                <!-- FLATS -->
                <li v-if="salesCard.project_land_site.flats_init == 'true' && projectHost != 'yassytower'"><a :href="salesCardPage.land_site_nav[5].link" @click="closeMobileMenu(!openSendwich)"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[5].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[5].name}}</a></li>
                <li v-if="salesCard.project_land_site.flats_init == 'true' && projectHost == 'yassytower'"><a :href="salesCardPage.land_site_nav[5].link" @click="closeMobileMenu(!openSendwich)"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[5].link,
                        offset: -100
                    }">Планировки</a></li>
                <!-- END FLATS -->
                <li v-if="salesCard.project_land_site.gallery_init == 'true'"><a :href="salesCardPage.land_site_nav[6].link" @click="closeMobileMenu(!openSendwich)"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[6].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[6].name}}</a></li>
                <li v-if="salesCard.project_land_site.news_init == 'true'"><a :href="salesCardPage.land_site_nav[7].link" @click="closeMobileMenu(!openSendwich)"
                    v-scroll-to="{
                        el: salesCardPage.land_site_nav[7].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[7].name}}</a></li>
                <li v-if="salesCard.project_land_site.contacts_init == 'true'"><a :href="salesCardPage.land_site_nav[8].link" @click="closeMobileMenu(!openSendwich)"
                    v-scroll-to="{ 
                        el: salesCardPage.land_site_nav[8].link,
                        offset: -100
                    }">{{salesCardPage.land_site_nav[8].name}}</a></li>
            </ul>
        </div>
        <!-- <navMain></navMain> -->
    </div>
</template>

<script>
    // import navMain from '@/components/nav-main/mobile-nav-main.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'mobileSidebar',
        data () {
            return {
                projectHost: window.host,
                lang: window.GlobalLang,
                dataLang: '',
            }
        },
        components: {
            // navMain,
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            openSendwich: 'loadOpenSendwich',
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
            setLocale(lang) {
                localStorage.setItem('languageShablon', lang);
                document.location.reload(true);
            },
            closeMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
            changeLang() {
                this.dataLang = window.body.data('language');
            },
            disableOverlay() {
                this.$store.commit('Open_Sendwich', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            }
        },
        created() {
        },
        mounted() {
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    if (newValue) {
                        this.changeLang();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/respond/mobile-sidebar/mobile-sidebar.scss';
    // @import '@/styles/components/nav-main/respond-nav-main.scss';
</style>